import React from "react";
import UserBadge from "../user-badge";
import { UserProfile } from "../../types";
import "./styles.scss"
import icons from "../../assets/icons.png"
import logos from "../../assets/right_top_logos_black.png"

interface HeaderProps {
    user: UserProfile;
    routeBack?: string
}

const Header: React.FC<HeaderProps> = ({ user, routeBack }) => {
    return (
        <header style={styles.header}>

            {
                routeBack != "" && routeBack != null && routeBack != undefined ?
                    <div style={{ marginLeft: "40px", }} className="header-text">
                        <img src={logos} style={{ width: "350px", height: "55px" }}></img>
                    </div>
                    :
                    <h2 style={{ marginLeft: "40px", }} className="header-text">Aplicações e sistemas</h2>
            }

            <div className="header-icons-mobile" style={{ marginLeft: "40px" }}>
                <img src={icons} style={{ width: "100px", height: "32px" }}></img>
            </div>
            <UserBadge user={user} propStyles={{ marginRight: "40px", }} />
        </header>
    );
};

const styles: Record<string, React.CSSProperties> = {
    header: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        background: "#fff",
        padding: "10px 0",
        borderBottom: "1px solid #ddd",
    },
};

export default Header;
